import { ThemeNames } from '@logz-ui/foundations';
export const applyThemeToDocument = (doc, theme) => {
    doc.documentElement.classList.remove('theme-light', 'theme-dark');
    doc.documentElement.classList.add(`theme-${theme === ThemeNames.Dark ? 'dark' : 'light'}`);
    doc.documentElement.setAttribute('data-theme', theme === ThemeNames.Dark ? 'dark' : 'light');
};
const NO_TRANSITION_STYLES = '*,*::before,*::after{transition:none !important;}';
export const suppressTransitionsDuringThemeSwap = (doc) => {
    const style = doc.createElement('style');
    style.appendChild(doc.createTextNode(NO_TRANSITION_STYLES));
    doc.head.appendChild(style);
    // Load-bearing: forces a sync recalc so the new colors apply while transitions are off.
    window.getComputedStyle(doc.body).getPropertyValue('opacity');
    return () => {
        if (style.parentNode) {
            style.parentNode.removeChild(style);
        }
    };
};
//# sourceMappingURL=utils.js.map